import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

export function reportAppBootstrapFailure(production: boolean): void {
  if (!production) {
    console.error('Automatick could not start.');
  }
}

bootstrapApplication(App, appConfig).catch(() =>
  reportAppBootstrapFailure(environment.production),
);
